import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement, BarElement } from 'chart.js';
import Next30DaysReport from './components/Next30DaysReport';
import SummaryCheckin from './components/SummaryCheckin';

type Props = {};
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement, BarElement);

export default function AgentDashboard({}: Props) {
  return (
    <div>
      <div className="row y-gap-20 justify-between items-end pb-20">
        <div className="col-12">
          <h1 className="text-30 lh-14 fw-600">Dashboard</h1>
          <div className="text-15 text-light-1">Agent dashboard</div>
        </div>
      </div>
      <Next30DaysReport />
      <div className="row y-gap-30 pt-20 chart_responsive">
        <SummaryCheckin />
      </div>
    </div>
  );
}
